import React from "react";
import CircleLoader from "react-spinners/ClipLoader";

const AppLoader = ({ size = 100 }) => {
  return (
    <div className="app-loader page h-full w-full flex justify-center items-center fixed bg-body">
      <CircleLoader color="#e3910a" size={size} aria-label="Loading" data-testid="loader" />
    </div>
  );
};

export default AppLoader;
